export const PHONE_DEALS_STYLES = {
  container: "bg-white rounded-2xl shadow-sm border border-gray-200 p-3 mb-4",
  content: "flex items-center gap-3",
  imageWrapper: "flex-shrink-0",
  image: "w-20 h-20 rounded-full object-cover",
  textContent: "flex-1",
  title: "text-sm font-bold text-ticketon-dark-blue mb-0",
  description: "text-sm text-ticketon-dark-blue mb-1.5",
  button: "inline-flex items-center px-3 py-2 rounded-lg bg-ticketon-light-sky-blue hover:bg-blue-50 transition-colors",
  buttonText: "flex items-center gap-1 text-sm text-ticketon-lighter-blue",
  phoneNumber: "font-bold",
} as const;
